import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { VisibilitySensor } from '@/components/functional/Scroll/VisibilitySensor';
import { bannerProMypageListItemStyle } from '@/feature/mypage/professional/component/BannerProMyPageListItem/style';
export const BannerProMyPageListItem = (props) => {
    const { banner, onClickBanner, onDisplayBanner } = props;
    const style = bannerProMypageListItemStyle();
    const [imgLoaded, setImgLoaded] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [alreadySent, setAlreadySent] = useState(false);
    // 画像ロードと可視判定がそろったら初回だけAPI送信
    useEffect(() => {
        if (!alreadySent && imgLoaded && isVisible) {
            onDisplayBanner(banner.id)();
            setAlreadySent(true);
        }
    }, [alreadySent, imgLoaded, isVisible, banner.id, onDisplayBanner]);
    return (_jsx("li", Object.assign({ className: style.item() }, { children: _jsx(VisibilitySensor, Object.assign({ onChange: setIsVisible }, { children: _jsx("div", { children: _jsx(DynamicLink, Object.assign({ onClick: onClickBanner(banner.id), target: '_blank', to: banner.url }, { children: _jsx("img", { alt: banner.title, className: style.thumbnail(), height: banner.thumbnail.height, onLoad: () => setImgLoaded(true), src: banner.thumbnail.src, width: banner.thumbnail.width }) })) }) })) })));
};
